import { useEffect } from "react";
import { FAQS } from "@/lib/site-data";

/** Injects FAQ JSON-LD schema into document head on mount. */
export default function FaqJsonLd() {
  useEffect(() => {
    const id = "xyro-faq-jsonld";
    if (document.getElementById(id)) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);
  return null;
}
